import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";

export default class extends Controller {
  static values = {
    phoneCallUrl: String,
  };

  triggerAiCall(event) {
    // For backwards compatibility, refactor phone calls controller to handle polymorphic resources better
    let callType = "";
    if (event.params.resourceType === "applicant_report") {
      callType = "applicant";
    } else if (event.params.resourceType === "reference") {
      callType = "reference";
    }

    post(this.phoneCallUrlValue, {
      body: {
        call_type: callType,
        [`${event.params.resourceType}_id`]: event.params.resourceId,
        order_id: event.params.orderId,
        ai_call_prompt: event.params.aiCallPrompt,
      },
      // Renders the server's turbo-stream response — the flash shown when a kill switch blocks
      // the call. A successful trigger is fire-and-forget (204, nothing to render).
      responseKind: "turbo-stream",
    }).catch((error) => console.error("Error:", error));
  }

  toggleDisabled(event) {
    this.element.disabled = !event.detail.phone;
  }
}
